import {
  ApiCarrier,
  BrandResponse,
  CategoriesResponse,
  DeliveryManager,
  PackageSizes,
  PartnerEshopResponse,
} from '../apiTypes';
import { ApiGroup } from '../model/ApiGroup';

export const mockGetCategories: CategoriesResponse = {
  categories: [
    {
      externalId: 'N068',
    },
    {
      externalId: 'N684',
    },
    {
      externalId: 'N001',
    },
    {
      externalId: 'N123',
    },
  ],
};

export const mockGetBrands: BrandResponse = {
  brands: [
    {
      externalId: 'BOSCH',
      title: 'Bosch',

    },
    {
      externalId: 'TS',
      title: 'Tesla',
    },
  ],
};

export const mockGetPartnerEshops: PartnerEshopResponse = {
  partners: [
    {
      id: 1,
      name: 'Partner',
      code: 'p1',
      apiGroups: [
        {
          code: ApiGroup.MALL_GROUP,
          eshops: [
            {
              id: 1,
              name: 'mall.cz',
              code: 'MALL.CZ',
            },
            {
              id: 2,
              name: 'mall.sk',
              code: 'MALL.SK',
            },
            {
              id: 3,
              name: 'mimovrste.com',
              code: 'MIMOVRSTE.COM',
            },
          ],
        },
        {
          code: ApiGroup.ALZA,
          eshops: [
            {
              id: 4,
              name: 'alza.cz',
              code: 'ALZA.CZ',
            },

          ],
        },
        {
          code: ApiGroup.KAUFLAND,
          eshops: [
            {
              id: 5,
              name: 'kaufland.cz',
              code: 'KAUFLAND.CZ',
            },

          ],
        },
        {
          code: ApiGroup.ALLEGRO,
          eshops: [
            {
              id: 6,
              name: 'allegro.cz',
              code: 'ALLEGRO.CZ',
            },
            {
              id: 7,
              name: 'allegro.sk',
              code: 'ALLEGRO.SK',
              baseMarketplaceCode: 'ALLEGRO.CZ',
            },
            {
              id: 8,
              name: 'allegro.hu',
              code: 'ALLEGRO.HU',
              baseMarketplaceCode: 'ALLEGRO.CZ',
            },
            {
              id: 9,
              name: 'allegro.pl',
              code: 'ALLEGRO.PL',
            },
          ],
        },
      ],
    },
  ],
};

export const mockGetCarriers : ApiCarrier[] = [
  {
    apiGroup: ApiGroup.MALL_GROUP,
    identifier: 'DPD',
    deliveryManager: DeliveryManager.MARKETPLACE,
  },
  {
    apiGroup: ApiGroup.MALL_GROUP,
    identifier: 'PPL',
    deliveryManager: DeliveryManager.MARKETPLACE,
  },
  {
    apiGroup: ApiGroup.ALZA,
    identifier: 'DPD',
    deliveryManager: DeliveryManager.MARKETPLACE,
  },
  {
    apiGroup: ApiGroup.MALL_GROUP,
    identifier: 'DPD',
    deliveryManager: DeliveryManager.PARTNER,
  },
  {
    apiGroup: ApiGroup.MALL_GROUP,
    identifier: 'PPL',
    deliveryManager: DeliveryManager.MPI,
  },
];

export const mockGetCancelReasons: String[] = ['out_of_stock', 'damaged_goods', 'wrong_price', 'external_supplier_failure', 'marketplace_request', 'other'];

export const mockGetPackageSizes : PackageSizes[] = [
  {
    size: 'XS',
    weight: 2000.0,
    length: 20.0,
    width: 30.0,
    height: 20.0,
  },
  {
    size: 'S',
    weight: 5000.0,
    length: 40.0,
    width: 30.0,
    height: 30.0,
  },
  {
    size: 'SM',
    weight: 10000.0,
    length: 60.0,
    width: 40.0,
    height: 30.0,
  },
  {
    size: 'M',
    weight: 15000.0,
    length: 70.0,
    width: 40.0,
    height: 40.0,
  },
  {
    size: 'ML',
    weight: 20000.0,
    length: 80.0,
    width: 40.0,
    height: 50.0,
  },
  {
    size: 'L',
    weight: 31000.0,
    length: 90.0,
    width: 40.0,
    height: 50.0,
  },
  {
    size: 'XL',
    weight: 50000.0,
    length: 120.0,
    width: 80.0,
    height: 90.0,
  },
  {
    size: 'XXL',
    weight: 200000.0,
    length: 120.0,
    width: 160.0,
    height: 120.0,
  },
];
